import { render } from "./CreatePlaylist.vue?vue&type=template&id=6d8e4bec"
import script from "./CreatePlaylist.vue?vue&type=script&lang=js"
export * from "./CreatePlaylist.vue?vue&type=script&lang=js"

import "./CreatePlaylist.vue?vue&type=style&index=0&id=6d8e4bec&lang=css"
script.render = render

export default script